<div #timelineWrapper id="timelineWrapper">
  <!-- Header  -->
  <svg class="timeline-header" xmlns="http://www.w3.org/2000/svg" [attr.height]="viewboxHeaderHeight" [attr.viewBox]="viewboxHeader" style="overflow:visible">
    <svg y="0" x="0" style="overflow:visible">
      <!-- Years -->
      @if ((type == TYPE_TABLE.Monthly || type == TYPE_TABLE.Weekly) && isMainPage) {
        <ng-container>
          @for (year of years; track trackByProperty('year')(m, year); let m = $index) {
            <g>
              <rect [attr.height]="BOX_SIZE" [attr.width]="checkBoxWidth(year, 'duration')" [attr.x]="checkBoxStart(year)" [attr.y]="year.positionY" class="box-date" />
              <text class="milestone" fill="rgb(50,50,50)" [attr.y]="year.positionYText" [attr.x]="checkBoxMiddle(year)" text-anchor="middle" dominant-baseline="central">
                {{year.year | date: 'yyyy' }}
              </text>
            </g>
          }
        </ng-container>
      }
      <!-- Months -->
      @for (month of months; track trackByProperty('month')(m, month); let m = $index) {
        <g>
          <rect [attr.height]="BOX_SIZE" [attr.width]="checkBoxWidth(month, 'duration')" [attr.x]="checkBoxStart(month)" [attr.y]="month.positionY" class="box-date" />
          <text class="milestone" fill="rgb(50,50,50)" [attr.y]="month.positionYText" [attr.x]="checkBoxMiddle(month)" text-anchor="middle" dominant-baseline="central">
            {{month.month | date: 'MMM - yy' }}
          </text>
        </g>
      }
      <!-- Weeks -->
      @if (type == TYPE_TABLE.Daily || type == TYPE_TABLE.Weekly) {
        <ng-container>
          @for (week of weeks; track trackByProperty('start_week')(w, week); let w = $index) {
            <g>
              <rect [attr.height]="BOX_SIZE" [attr.width]="checkBoxWidth(week)" [attr.x]="checkBoxStart(week)" [attr.y]="week.positionY" class="box-date" />
              @if (isMainPage) {
                <text class="milestone" fill="rgb(50,50,50)" [attr.y]="week.positionYText" [attr.x]="checkBoxMiddle(week)" text-anchor="middle" dominant-baseline="central">
                  {{week.start_week | date: 'dd' }} - {{week.end_week | date: 'dd' }}
                </text>
              }
              @if (!isMainPage) {
                <text class="milestone" fill="rgb(50,50,50)" [attr.y]="week.positionYText" [attr.x]="checkBoxMiddle(week)" text-anchor="middle" dominant-baseline="central">
                  {{week.start_week | date: 'dd' }}
                </text>
              }
            </g>
          }
        </ng-container>
      }
      <!-- Days -->
      @if (type == TYPE_TABLE.Daily) {
        <ng-container>
          @for (day of days; track trackByProperty('date')(d, day); let d = $index) {
            <g>
              <rect [attr.height]="BOX_SIZE" [attr.width]="BOX_SIZE" [attr.x]="checkBoxStart(day)" [attr.y]="day.positionY" class="box-date"
                [ngClass]="{'holiday': day.isSunday || day.holliday}"/>
              <text class="milestone" fill="rgb(50,50,50)" [attr.y]="day.positionYText" [attr.x]="checkBoxMiddle(day)"  text-anchor="middle" dominant-baseline="central">
                <tspan alignment-baseline="text-after-edge" >	{{day.date | date: 'dd'}} </tspan>
              </text>
              <text class="milestone" fill="rgb(50,50,50)" [attr.y]="day.positionYText" [attr.x]="checkBoxMiddle(day)" text-anchor="middle" dominant-baseline="central">
                <tspan alignment-baseline="text-before-edge">{{day.date | date: 'E'|slice:0:1}} </tspan>
              </text>
              @if (day.holliday) {
                <ng-container>
                  <!-- <text class="milestone text-holiday bg" fill="rgb(50,50,50)" [attr.y]="day.positionYText + 15" [attr.x]="checkBoxMiddle(day)" text-anchor="middle">
                  <ng-container *ngFor="let letter of [].constructor(day.holliday_country_abbr.length)">|||</ng-container>
                </text> -->
                <text class="milestone text-holiday" fill="rgb(50,50,50)" [attr.y]="day.positionYText + 20" [attr.x]="checkBoxMiddle(day)" text-anchor="middle">
                  {{day.holliday_country_abbr}}
                </text>
              </ng-container>
            }
          </g>
        }
      </ng-container>
    }
  </svg>
</svg>

<!-- Timeline table -->
<div class="wrapper-graphs" [ngClass]="{ 'with-scroll-end': isMainPage }">
  <div class="bar left" [ngStyle]="{'height.px': viewboxTableHeight}" (click)="paginateTable('previous')">
    <span class="material-icons arrow">keyboard_arrow_left</span>
  </div>
  <svg class="timeline-table" xmlns="http://www.w3.org/2000/svg" [attr.height]="viewboxTableHeight" [attr.viewBox]="viewboxTable">
    <defs>
      <pattern id="pattern-stripe"
        width="14" height="4"
        patternUnits="userSpaceOnUse"
        patternTransform="rotate(45)">
        <rect width="4" height="4" transform="translate(0,0)" fill="white"></rect>
      </pattern>
      <mask id="mask-stripe">
        <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-stripe)" />
      </mask>
    </defs>
    <!-- Vertical lines -->
    <ng-container>
      @switch (type) {
        @case (TYPE_TABLE.Daily) {
          <svg y="0" x="0">
            @for (day of days; track day; let a = $index; let lastDay = $last) {
              <g>
                <line class="vertical-line" [attr.x1]="checkBoxStart(day, 'day')" y1="0" [attr.x2]="checkBoxStart(day, 'day')" [attr.y2]="viewboxTableHeight"
                  [ngStyle]="{'stroke-width': day.isSunday || day.holliday ? unitSize : 1}" [ngClass]="{'holiday': day.isSunday || day.holliday}"/>
                <!-- <line *ngIf="lastDay" [attr.x1]="checkBoxStart(day) + BOX_SIZE" y1="0" [attr.x2]="checkBoxStart(day) + BOX_SIZE" [attr.y2]="viewboxTableHeight" style="stroke:rgb(230,230,230);stroke-width:1" /> -->
              </g>
            }
          </svg>
        }
        @case (TYPE_TABLE.Weekly) {
          <svg y="0" x="0">
            @for (week of weeks; track week; let a = $index; let lastWeek = $last) {
              <g>
                <line class="vertical-line" [attr.x1]="checkBoxStart(week)" y1="0" [attr.x2]="checkBoxStart(week)" [attr.y2]="viewboxTableHeight" />
                <!-- <line *ngIf="lastWeek" [attr.x1]="checkBoxStart(week) + BOX_SIZE" y1="0" [attr.x2]="checkBoxStart(week) + BOX_SIZE" [attr.y2]="viewboxTableHeight" style="stroke:rgb(230,230,230);stroke-width:1" /> -->
              </g>
            }
          </svg>
        }
        @case (TYPE_TABLE.Monthly) {
          <svg y="0" x="0">
            @for (month of months; track month; let a = $index; let lastMonth = $last) {
              <g>
                <line class="vertical-line" [attr.x1]="checkBoxStart(month)" y1="0" [attr.x2]="checkBoxStart(month)" [attr.y2]="viewboxTableHeight"/>
                <!-- <line *ngIf="lastMonth" [attr.x1]="checkBoxStart(month) + BOX_SIZE" y1="0" [attr.x2]="checkBoxStart(month) + BOX_SIZE" [attr.y2]="viewboxTableHeight" style="stroke:rgb(230,230,230);stroke-width:1" /> -->
              </g>
            }
          </svg>
        }
      }
    </ng-container>

    @for (project of projects; track _gS.trackById($index, project)) {
      <ng-container>
        @for (phase of project.phases_project; track _gS.trackById(i, phase); let i = $index; let firstPhase = $first) {
          <svg class="parent_milestones" [attr.y]="phase.positionY" [attr.x]="0">
            <!-- Horizontal lines -->
            @if (project.isOpen) {
              <ng-container>
                @if (firstPhase) {
                  <line x1="0" [attr.y1]="0" [attr.x2]="viewboxTableWidth" [attr.y2]="0" style="stroke:rgb(230,230,230);stroke-width:1" />
                }
                <line x1="0" [attr.y1]="BOX_SIZE" [attr.x2]="viewboxTableWidth" [attr.y2]="BOX_SIZE" style="stroke:rgb(230,230,230);stroke-width:1" />
              </ng-container>
            }
            @if (!phase.isDetail) {
              <svg y="0" x="0">
                <rect [attr.height]="project.isOpen ? BOX_SIZE : BOX_SIZE / 2" [attr.width]="checkBoxWidth(phase, 'duration')" [attr.x]="checkBoxStart(phase)" y="0" [attr.fill]="phase.color_code" stroke="rgb(230,230,230)" />
              </svg>
            }
            @if (phase.isDetail) {
              <svg y="0" x="0">
                @for (week of phase.weeksDetail; track week; let i = $index) {
                  <ng-container >
                    <rect [attr.height]="project.isOpen ? BOX_SIZE : BOX_SIZE / 2" [attr.width]="7*unitSize" [attr.x]="checkBoxStart(phase) + (7*unitSize*i)" y="0" [attr.fill]="'rgb(255,255,255)'" stroke-width="4" [attr.stroke]="phase.color_code" />
                    <text class="detail" [attr.y]="BOX_SIZE / 2" [attr.x]="checkBoxStart(phase) + (7*unitSize*i) + ((7*unitSize)/2)" text-anchor="middle" dominant-baseline="central">
                      W{{ week.week }}
                    </text>
                  </ng-container>
                }
              </svg>
            }
            @if (phase.isOpen && project.isOpen) {
              <ng-container>
                @for (task of phase.tasks; track _gS.trackById(a, task); let a = $index) {
                  <svg class="child_milestones" x="0" [attr.y]="task.positionY">
                    <line x1="0" [attr.y1]="BOX_SIZE" [attr.x2]="viewboxTableWidth" [attr.y2]="BOX_SIZE" style="stroke:rgb(230,230,230);stroke-width:1" />
                    @if (task.details.length) {
                      <svg y="0" x="0">
                        @for (detail of task.details; track _gS.trackById($index, detail)) {
                          <ng-container >
                            <!-- Break -->
                            @if (!detail.skip && (detail.break || detail.break_real_duration)) {
                              <g>
                                @if (detail.break || detail.break_real_duration) {
                                  <rect
                                    class="hbar"
                                    [attr.height]="BOX_SIZE"
                                    [attr.width]="checkBoxWidth(detail, 'break_real_duration')"
                                    [attr.x]="checkBoxStart(detail, null, 'break_real_start')"
                                    [attr.y]="0"
                                    [attr.fill]="task.color_border || phase.color_code"
                                    [attr.stroke]="task.color_border || phase.color_code"
                                    stroke-width="2">
                                  </rect>
                                }
                              </g>
                            }
                            <!-- Box -->
                            @if (!detail.skip) {
                              <g (contextmenu)="onContextChapterTask($event, project, phase, task, detail)">
                                <rect [attr.height]="BOX_SIZE" [attr.width]="checkBoxWidth(detail)" [attr.x]="checkBoxStart(detail)" y="0" [attr.fill]="task.color_code" [attr.stroke]="task.color_border || phase.color_code" stroke-width="2">
                                </rect>
                                <text class="detail" [attr.y]="BOX_SIZE / 2" [attr.x]="checkBoxMiddle(detail)" text-anchor="middle" dominant-baseline="central">
                                  {{detail.text}}
                                </text>
                              </g>
                            }
                          </ng-container>
                        }
                      </svg>
                    }
                    @if (!task.details.length) {
                      <svg y="0" x="0">
                        <g (contextmenu)="onContextTask($event, project, phase, task)">
                          <rect [attr.height]="BOX_SIZE" [attr.width]="checkBoxWidth(task)" [attr.x]="checkBoxStart(task)" y="0" [attr.fill]="task.color_code" [attr.stroke]="task.color_border || phase.color_code" stroke-width="2"/>
                          <text class="detail" [attr.y]="BOX_SIZE / 2" [attr.x]="checkBoxMiddle(task)" text-anchor="middle" dominant-baseline="central">
                            {{task.text}}
                          </text>
                        </g>
                      </svg>
                    }
                  </svg>
                }
              </ng-container>
            }
          </svg>
        }
      </ng-container>
    }

    @if (type == TYPE_TABLE.Daily) {
      <svg y="0" x="0">
        @for (day of days; track day; let a = $index; let lastDay = $last) {
          <ng-container>
            @if (day.isSunday || day.holliday) {
              <g>
                <line class="vertical-line opacity" [attr.x1]="checkBoxStart(day, 'day')" y1="0" [attr.x2]="checkBoxStart(day, 'day')" [attr.y2]="viewboxTableHeight"
                  [ngStyle]="{'stroke-width': day.isSunday || day.holliday ? unitSize : 1}" [ngClass]="{'holiday': day.isSunday || day.holliday, 'day_saturday': day.isSaturday}"/>
                <!-- <line *ngIf="lastDay" [attr.x1]="checkBoxStart(day) + BOX_SIZE" y1="0" [attr.x2]="checkBoxStart(day) + BOX_SIZE" [attr.y2]="viewboxTableHeight" style="stroke:rgb(230,230,230);stroke-width:1" /> -->
              </g>
            }
          </ng-container>
        }
      </svg>
    }

    <!-- Mark today -->
    @if (todayInfoDay) {
      <svg y="0" x="0">
        <g>
          <line class="vertical-line today" [attr.x1]="todayStart(todayInfoDay)" y1="0" [attr.x2]="todayStart(todayInfoDay)" [attr.y2]="viewboxTableHeight" />
        </g>
      </svg>
    }
  </svg>
  <div class="bar right" [ngStyle]="{'height.px': viewboxTableHeight}" (click)="paginateTable('next')">
    <span class="material-icons arrow">keyboard_arrow_right</span>
  </div>
</div>
</div>
